import Vue from '@/main'

const getInvalidFeedback = (validationObject) => {
  if (validationObject.$pending) {
    return Vue.$t('vuelidate.invalid-feedback.pending')
  } else if (validationObject.hasOwnProperty('required') && !validationObject.required) {
    return Vue.$t('vuelidate.invalid-feedback.required')
  } else if (validationObject.hasOwnProperty('maxLength') && !validationObject.maxLength) {
    return Vue.$t('vuelidate.invalid-feedback.maxLength', [validationObject.$params.maxLength.max])
  } else if (validationObject.hasOwnProperty('numeric') && !validationObject.numeric) {
    return Vue.$t('vuelidate.invalid-feedback.numeric')
  } else if (validationObject.hasOwnProperty('email') && !validationObject.email) {
    return Vue.$t('vuelidate.invalid-feedback.email')
  }

  return Vue.$t('vuelidate.invalid-feedback.default')
}

export { getInvalidFeedback }
